import { render, staticRenderFns } from "./sign-up-for.vue?vue&type=template&id=0c8cef18&scoped=true&"
import script from "./sign-up-for.vue?vue&type=script&lang=js&"
export * from "./sign-up-for.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8cef18",
  null
  
)

export default component.exports